import { ReturnReason } from '@core/enums/return-reason';

export const ReturnReasonLocale = {
  [ReturnReason.MissingParts]: $localize`Missing parts`,
  [ReturnReason.Damaged]: $localize`Damaged`,
  [ReturnReason.PackingError]: $localize`Packing error`,
};
